module.exports = __webpack_public_path__ + "static/media/Prince-example.91b419d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/Prince-example.png
// module id = 358
// module chunks = 0